/*
 *
 * RemoveShelfButton reducer
 *
 */

import ActionTypes from './constants';
import { ContainerState } from './types';
import ActionTypesModeBar from '../../ModeBar/constants';

export const initialState: ContainerState = {
  shelf: undefined,
};

function removeShelfButtonReducer(
  state: ContainerState = initialState,
  action: any,
): ContainerState {
  switch (action.type) {
    case ActionTypes.RECENT_MODIFIED_SHELF:
      return { ...state, shelf: action.payload.shelf };
    case ActionTypesModeBar.SWITCH_MODE:
      return { ...state, shelf: undefined };
    default:
      return state;
  }
}

export default removeShelfButtonReducer;
